import React from "react";
import styled from 'styled-components'
import Container from '@material-ui/core/Container';
import {H4, StyledInput, StyledButton, StyledError} from "../../../../component/Typeset";


const StyledLink = styled.div`
  margin: 10px 0;
  cursor: pointer;
  color: white;
  font-size: 0.8rem;
`;

class CreateAccountForm extends React.Component {
  state = {
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    password1: "",
  };

  handleTextChange = (event, attrName) => {
    const text = event.target.value;
    this.props.onChange(attrName, text);
    this.setState({ [attrName]: text });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.props.onSubmit(this.state);
  };

  render = () => {
    const {errors = {}} = this.props;

    return (
      <Container maxWidth={'xs'}>
        <div style={{backgroundColor: 'rgba(39, 37, 37, .85)', borderRadius: 8, padding: '30px'}}>
          <H4 style={{textAlign: 'center', marginBottom: 40}}>Create New Account</H4>
          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Email</div>
              <StyledInput
                type="email"
                value={this.state.email}
                placeholder={'Email'}
                onChange={(e) => this.handleTextChange(e, 'email')}
              />
              {errors && errors.email && <StyledError>{errors.email}</StyledError>}
            </div>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>First name</div>
              <StyledInput
                type="text"
                value={this.state.first_name}
                placeholder={'First name'}
                onChange={(e) => this.handleTextChange(e, 'first_name')}
              />
              {errors && errors.first_name && <StyledError>{errors.first_name}</StyledError>}
            </div>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Last name</div>
              <StyledInput
                type="text"
                value={this.state.last_name}
                placeholder={'Last name'}
                onChange={(e) => this.handleTextChange(e, 'last_name')}
              />
              {errors && errors.last_name && <StyledError>{errors.last_name}</StyledError>}
            </div>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Password</div>
              <StyledInput
                type="password"
                placeholder={'Password'}
                value={this.state.password}
                onChange={(e) => this.handleTextChange(e, 'password')}
              />
              {errors && errors.password && <StyledError>{errors.password}</StyledError>}
            </div>
            <div>
              <div style={{fontSize: '0.8rem', marginBottom: 6}}>Repeat password</div>
              <StyledInput
                type="password"
                placeholder={'Repeat password'}
                value={this.state.password1}
                onChange={(e) => this.handleTextChange(e, 'password1')}
              />
              {errors && errors.password1 && <StyledError>{errors.password1}</StyledError>}
              {errors && errors.non_field_errors && <StyledError>{errors.non_field_errors[0]}</StyledError>}
            </div>
            <StyledButton type="submit" style={{marginTop: 15}} disabled={this.props.isLoading}>Create Account</StyledButton>
            <div style={{textAlign: 'right', marginTop: 10}}>
              <StyledLink onClick={() => this.props.onClose()}>
                Have an account? Sign in here.
              </StyledLink>
            </div>
          </form>
        </div>
      </Container>
    );
  };
}

export default CreateAccountForm;
